import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=1b6813d7&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=1b6813d7&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6813d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6813d7')) {
      api.createRecord('1b6813d7', component.options)
    } else {
      api.reload('1b6813d7', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=1b6813d7&scoped=true", function () {
      api.rerender('1b6813d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/FinancialTerminal/components/Banner.vue"
export default component.exports